'use client';
import styled from 'styled-components';

export const StyledSplitScreenPromo = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media ${props => props.theme.laptop} {
    grid-template-columns: repeat(2, 1fr);
  }
  &:last-child {
    margin-bottom: 70px;
  }
  overflow: hidden;
`;

export const Content = styled.div`
  padding: ${props => props.theme.spacing(10, 6)};
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  color: ${props =>
    props.$fontColor && props.theme.colors.get(props.$fontColor)};
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(13, 20)};
  }

  @media ${props => props.theme.laptopL} {
    padding: ${props => props.theme.spacing(13, 32.5)};
  }
`;

export const ButtonContainer = styled.div`
  margin-top: ${props => props.theme.spacing(8)};
  display: flex;
  justify-content: ${props =>
    props.theme.getJustifyContent(props.$linkAlignment)};
  text-align: ${props => props.$linkAlignment || 'center'};
`;

export const InfoContainer = styled.div`
  margin-top: ${props => props.theme.spacing(5)};
`;

export const ImageContainer = styled.div`
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};

  @media ${props => props.theme.mobileS} {
    grid-row: 1;
    grid-column: 1;
  }

  @media ${props => props.theme.laptop} {
    grid-row: ${props => (props.$imageFirst ? '1' : 'auto')};
    grid-column: ${props => (props.$imageFirst ? '1' : 'auto')};

    img {
      width: auto;
      min-height: 100%;
      min-width: 100%;
      object-fit: cover;
    }
  }
`;

export const VideoContainer = styled.div`
  overflow: hidden;
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};

  mux-player {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
  }

  @media ${props => props.theme.mobileS} {
    grid-row: 1;
    grid-column: 1;
  }

  @media ${props => props.theme.laptop} {
    grid-row: ${props => (props.$imageFirst ? '1' : 'auto')};
    grid-column: ${props => (props.$imageFirst ? '1' : 'auto')};
  }
`;
export const MultiImageContainer = styled.div`
  margin-top: ${props => props.theme.spacing(16)};
  position: relative;
  height: 0;

  @media ${props => props.theme.mobileS} {
    grid-row: 1;
    grid-column: 1;
    padding-bottom: 90%;
  }

  @media ${props => props.theme.laptop} {
    margin-top: 0;
    grid-row: ${props => (props.$imageFirst ? '1' : 'auto')};
    grid-column: ${props => (props.$imageFirst ? '1' : 'auto')};
    height: 100%;
    padding-bottom: 0;
    overflow: hidden;
  }
`;

export const MultiImageGroup = styled.div`
  position: absolute;
  inset: 0;

  @media ${props => props.theme.laptop} {
    inset: unset;
    width: 100%;
    max-width: 720px;
    aspect-ratio: 10 / 9;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
  }

  @media ${props => props.theme.laptopL} {
    aspect-ratio: unset;
    height: 100%;
    top: 0;
    transform: none;
  }
`;

export const BackImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: ${props => (props.$imageFirst ? 'auto' : '5%')};
  right: ${props => (props.$imageFirst ? '5%' : 'auto')};
  width: 58%;
  aspect-ratio: 1 / 1;
  border-radius: ${props => props.theme.spacing(4)};
  overflow: hidden;
  z-index: 1;
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};

  @media ${props => props.theme.laptop} {
    top: 4%;
    left: ${props => (props.$imageFirst ? 'auto' : '13%')};
    right: ${props => (props.$imageFirst ? '13%' : 'auto')};
    width: auto;
    height: 60%;
    max-height: 360px;
  }

  img {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }
`;

export const FrontImageWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: ${props => (props.$imageFirst ? 'auto' : '26.5%')};
  right: ${props => (props.$imageFirst ? '26.5%' : 'auto')};
  max-height: 60%;
  width: 68%;
  aspect-ratio: 4 / 3;
  border-radius: ${props => props.theme.spacing(4)};
  overflow: hidden;
  z-index: 2;

  @media ${props => props.theme.laptop} {
    top: 39%;
    bottom: auto;
    left: ${props => (props.$imageFirst ? 'auto' : '30%')};
    right: ${props => (props.$imageFirst ? '30%' : 'auto')};
    width: auto;
    height: 60%;
    max-height: 390px;
  }

  img {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }
`;

export const BadgesWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(10)};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: ${props => props.theme.spacing(6)};
  grid-row-gap: ${props => props.theme.spacing(5)};
  align-self: center;
  align-items: center;

  > * {
    justify-self: center;
  }

  > *:first-child {
    grid-column: 1 / -1;
    max-width: calc(50% - ${props => props.theme.spacing(1)});
  }

  > *:not(:first-child) {
    transform: scale(0.9);
  }

  @media ${props => props.theme.laptop} {
    align-self: flex-start;
    display: flex;
    gap: ${props => props.theme.spacing(10)};
    justify-content: flex-start;

    > *:first-child {
      max-width: unset;
    }

    > *:not(:first-child) {
      transform: none;
    }
  }
`;

export const TypewriterStyledEyebrowContainer = styled.div`
  display: inline-flex;
  align-items: center;
  min-height: 1lh;
  overflow: visible;
  margin-bottom: ${props => props.theme.spacing(2)};
`;
export const TypewriterStyledEyebrow = styled.p`
  ${props => props.theme.typography[props.$typography]};
  ${props => props.theme.fontFamily.fuzzyBubbles};
  color: ${props =>
    props.theme.colors.get(props.$fontColor, props.theme.colors.text.primary)};
`;
